import React, { useState, useEffect } from 'react';
import {
  TextInput,
  Field,
  Fieldset,
  FieldBody,
  Button,
  CheckIcon,
  Alert,
} from '@emorg-prd/react-standard';
import './index.css';
import NuvoloService from '../../../../api/NuvoloService';
import BuildingSourceSystemRelate from '../../../../api/BuildingSourceSystemRelate';
import SourceSystemIdType from '../../../../api/SourceSystemIdType';
import StatusCodes from 'node-modules-http-status-codes'; // if error run in terminal $npm install http-status-codes --save
import ProgressTabNavigator from '../ProgressTabNavigator';

function LocationBuilding(props) {
  let {
    buildingList,
    onChange,
    handlePageError,
    onNavigateForward,
    onNavigateBackward,
    onSetProgressTabComplete,
  } = props;
  const [nuvoloSiteTypeId, setNuvoloSiteTypeId] = useState();

  useEffect(() => {
    var isLoading = true;
    window.scrollTo(0, 0);
    SourceSystemIdType.getAll().then((res) => {
      if (isLoading) {
        res.sort((a, b) => {
          return a.sourceSystemIdTypeName.localeCompare(b.sourceSystemIdTypeName);
        });
        var nuvoloSiteSourceSystemIdType = res.find(
          (type) => type.sourceSystemIdTypeName?.toLowerCase() === 'nuvolo_site_id'
        );
        setNuvoloSiteTypeId(nuvoloSiteSourceSystemIdType.sourceSystemIdTypeId);
        if (buildingList) {
          buildingList.forEach((building) => building.sourceSystemIdTypeId = nuvoloSiteTypeId);
        }
      }
    }).catch((error) => {
      handlePageError(error.message);
    });

    if (buildingList) {
      buildingList.forEach((building) => {
        if (
          building.sourceSystemReferenceId &&
          building.previousNuvoloBuildingId &&
          building.previousNuvoloBuildingId?.toLowerCase() === building.sourceSystemReferenceId?.toLowerCase()
        ) {
          building.isNuvoloBuildingValid = true;
          building.validationSymbol = '';
        }
        if (!building.isNuvoloBuildingValid) {
          building.validationSymbol = 'Validate';
        }
      });
      onChange('buildingList', buildingList);
    }
    onSetProgressTabComplete();
    return () => {
      isLoading = false;
    };
  }, []);

  useEffect(() => {
    if (buildingList) {
      buildingList.forEach((building) => building.sourceSystemIdTypeId = nuvoloSiteTypeId);
      onChange('buildingList', buildingList);
    }
  }, [nuvoloSiteTypeId]);

  const handleBuildingChange = (input, index, event) => {
    let buildingListCopy = [...buildingList];
    let buildingObject = buildingListCopy[parseInt(index)];
    switch (input) {
      case 'name':
        buildingObject.buildingName = event.target.value;
        break;
      case 'desc':
        buildingObject.buildingDesc = event.target.value;
        break;
      case 'reference':
        buildingObject.sourceSystemReferenceId = event.target.value;
        if (
          buildingObject.previousNuvoloBuildingId &&
          event.target.value?.toLowerCase() === buildingObject.previousNuvoloBuildingId?.toLowerCase()
        ) {
          buildingObject.isNuvoloBuildingValid = true;
          buildingObject.validationSymbol = '';
          buildingObject.validationErrorMessage = '';
        } else {
          buildingObject.isNuvoloBuildingValid = false;
          buildingObject.validationSymbol = 'Validate';
        }
        break;
      default:
        break;
    }
    onChange('buildingList', buildingListCopy);
  };

  const addBuilding = () => {
    const values = [...buildingList];
    values.push({
      buildingName: '',
      buildingDesc: '',
      sourceSystemReferenceId: '',
      sourceSystemIdTypeId: nuvoloSiteTypeId,
      isNuvoloBuildingValid: false,
      previousNuvoloBuildingId: '',
      validationSymbol: '',
      loadingValidation: false,
      validationErrorMessage: '',
    });
    onChange('buildingList', values);
  };

  const removeBuilding = (index) => {
    const values = [...buildingList];
    if (values.length > 1) {
      values.splice(index, 1);
      onChange('buildingList', values);
    } else {
      const emptyBuildingList = [{
        buildingName: '',
        buildingDesc: '',
        sourceSystemReferenceId: '',
        sourceSystemIdTypeId: nuvoloSiteTypeId,
        isNuvoloBuildingValid: false,
        previousNuvoloBuildingId: '',
        validationSymbol: '',
        loadingValidation: false,
        validationErrorMessage: '',
      }];
      onChange('buildingList', emptyBuildingList);
    }
  };

  async function validateBuildingSourceSystemReferenceId (
    index,
    sourceSystemReferenceId
  ) {
    let buildingListCopy = [...buildingList];
    let buildingObject = buildingListCopy[parseInt(index)];
    buildingObject.loadingValidation = true;
    buildingObject.isNuvoloBuildingValid = false;
    onChange('buildingList', buildingListCopy);

    let validationObject = {
      referenceExistsInNuvolo: null,
      referenceExistsInUdm: null,
      errorOnUdm: null,
      errorOnNuvolo: null,
      sourceSystemReferenceId: sourceSystemReferenceId,
      message: ''
    };

    await BuildingSourceSystemRelate.validateBuildingReferenceId(sourceSystemReferenceId)
      .then((udmRes) => {
        if (udmRes.status == StatusCodes.NO_CONTENT) { // ssr not in UDM
          validationObject.referenceExistsInUdm = false;
          validationObject.errorOnUdm = false;

          NuvoloService.getBuilding(sourceSystemReferenceId).then((nuvoloRes) => {
            if (nuvoloRes.status == StatusCodes.OK) {
              if (nuvoloRes.data.message?.includes('does not exist')) { // building not in Nuvolo
                validationObject.errorOnNuvolo = true;
                validationObject.referenceExistsInNuvolo = false;
                validationObject.message = 'Source System Reference Id does not exist in Nuvolo';
                buildingObject.validationSymbol = 'Validate';
              } else { // campus in Nuvolo, positive validation
                validationObject.referenceExistsInNuvolo = true;
                validationObject.errorOnNuvolo = false;
                buildingObject.isNuvoloBuildingValid = true;
                buildingObject.validationSymbol = '';
              }
            } else { // Nuvolo error
              validationObject.errorOnNuvolo = true;
              validationObject.message = 'Error: Cannot connect to Nuvolo';
              buildingObject.validationSymbol = 'Validate';
            }
            buildingObject.validationErrorMessage = validationObject.message;
            buildingObject.loadingValidation = false;
            onChange('buildingList', buildingListCopy);
          });
        } else if (udmRes.status == StatusCodes.OK) { // ssr in UDM
          if (buildingObject.previousNuvoloBuildingId?.toLowerCase() !== sourceSystemReferenceId.toLowerCase()) { // previous ssr does not match
            validationObject.errorOnUdm = true;
            validationObject.referenceExistsInUdm = true;
            validationObject.message = 'Source System Reference Id already exists in UDM'
            buildingObject.validationSymbol = 'Validate';
          } else { // previous ssr does match, positive validation
            buildingObject.isNuvoloBuildingValid = true;
            validationObject.message = '';
          }
          buildingObject.validationErrorMessage = validationObject.message;
          buildingObject.loadingValidation = false;
          onChange('buildingList', buildingListCopy);
        } else {
          validationObject.errorOnUdm = true;
          validationObject.message = 'Error: Contact your UDM Admin'
          buildingObject.validationSymbol = 'Validate';
          buildingObject.loadingValidation = false;
          onChange('buildingList', buildingListCopy);
        }
        buildingObject.validationErrorMessage = validationObject.message;
      }).catch((error) => {
        validationObject.errorOnUdm = true;
        validationObject.message = 'Error: Contact your UDM Admin'
        buildingObject.validationSymbol = 'Validate';
        buildingObject.loadingValidation = false;
        buildingObject.validationErrorMessage = validationObject.message;
        onChange('buildingList', buildingListCopy);
      });

    return validationObject;
  };

  return (
    <div className='page'>
      <Fieldset>
        {buildingList.map((buildingObject, index) => (
          <Field key={`${index}`}>
            <div>
              <Alert
                variant='error'
                style={{
                  marginBottom: '15px',
                  marginRight: '15px',
                  display:
                  buildingObject.validationErrorMessage != ''
                      ? 'flex' : 'none'
                }}
              >
                {buildingObject.validationErrorMessage}
              </Alert>
            </div>
            <FieldBody>
              <div className='building-row'>
                <TextInput
                  className='building-input'
                  label='Building Name'
                  value={buildingObject.buildingName}
                  onChange={(e) => handleBuildingChange('name', index, e)}
                />

                <TextInput
                  className='building-input'
                  label='Building Description'
                  value={buildingObject.buildingDesc}
                  onChange={(e) => handleBuildingChange('desc', index, e)}
                />

                <form>
                  <div className='em-c-search__body'>
                    <TextInput
                      className='building-reference'
                      label='Nuvolo Source System Reference Id'
                      placeholder=''
                      inputProps={{
                        className: buildingObject.sourceSystemReferenceId ? 'reference-id' : 0
                      }}
                      value={buildingObject.sourceSystemReferenceId}
                      error={buildingObject.sourceSystemReferenceId !== '' && !buildingObject.isNuvoloBuildingValid}
                      onChange={(e) => handleBuildingChange('reference', index, e)}
                    />
                    <Button
                      style={{
                        display:
                          buildingObject.sourceSystemReferenceId !== '' &&
                          !buildingObject.loadingValidation ? 'block' : 'none',
                      }}
                      className={
                        buildingObject.sourceSystemReferenceId !== '' &&
                        !buildingObject.isNuvoloBuildingValid
                          ? 'small-margin validation-button red-outline'
                          : 'small-margin validation-button grey-outline'
                      }
                      variant='secondary'
                      size='medium'
                      error={buildingObject.sourceSystemReferenceId !== '' && !buildingObject.isNuvoloBuildingValid}
                      onClick={(e) => validateBuildingSourceSystemReferenceId(index, buildingObject.sourceSystemReferenceId)}
                    >
                      {buildingObject.validationSymbol}
                      <CheckIcon
                        style={{ display : buildingObject.isNuvoloBuildingValid ? 'block' : 'none' }}
                      />
                    </Button>
                    <Button
                      style={{ display: buildingObject.loadingValidation ? 'block' : 'none' }}
                      className='small-margin validation-button'
                      loading
                      size='medium'
                    >
                      Loading
                    </Button>
                  </div>
                </form>
                <Button
                  className='small-margin'
                  variant='tertiary'
                  size='small'
                  onClick={() => removeBuilding(index)}
                  style={{ paddingTop: '42px', paddingLeft: '25px' }}
                >
                  × Remove Building
                </Button>
              </div>
            </FieldBody>

          </Field>
        ))}

        <Button
          className='small-margin'
          variant='tertiary'
          size='small'
          onClick={addBuilding}
        >
          + Add Building
        </Button>
      </Fieldset>

      <ProgressTabNavigator
        onNavigateBackward={onNavigateBackward}
        onNavigateForward={onNavigateForward}
      > 
      </ProgressTabNavigator>
    </div>
  );
}
export default LocationBuilding;